import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.dispatchEvent(new CustomEvent('device-check:error', {
      bubbles: true,
      detail: { success: false }
    }))
  }
}
